<template>
    <!-- page-wrapper Start-->
    <div class="page-wrapper">
        <div class="container-fluid">
            <!-- sign up page start-->
            <div class="authentication-main">
                <div class="row">
                    <div class="col-sm-12 p-0">
                        <div class="auth-innerright">
                            <div class="authentication-box">
                                <div class="text-center"><img alt="" src="../assets/images/logo-dark.png" width="150"></div>
                                <div class="card mt-4 p-4">
                                    <h4 class="text-center text-uppercase">Sign Up for a Content Creator Account</h4>
                                    <form class="theme-form" @submit.prevent="handleSubmit">
                                        <div class="form-row">
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label for="firstName" class="col-form-label">First Name <span>*</span></label>
                                                    <input type="text" v-model="user.firstName" id="firstName" name="firstName" class="form-control" :class="{ 'is-invalid': submitted && $v.user.firstName.$error }" />
                                                    <div v-if="submitted && !$v.user.firstName.required" class="invalid-feedback">First Name is required</div>
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label for="lastName" class="col-form-label">Last Name <span>*</span></label>
                                                    <input type="text" v-model="user.lastName" id="lastName" name="lastName" class="form-control" :class="{ 'is-invalid': submitted && $v.user.lastName.$error }" />
                                                    <div v-if="submitted && !$v.user.lastName.required" class="invalid-feedback">Last Name is required</div>
                                                </div>
                                            </div>
                                        </div>
                                      <div class="form-group">
                                        <label for="companyName" class="col-form-label">Company Name</label>
                                        <input type="text" v-model="user.companyName" id="companyName" name="confirmPassword" class="form-control" />
                                      </div>
                                        <div class="form-group">
                                            <label for="email" class="col-form-label">Email <span>*</span></label>
                                            <input type="email" v-model="user.email" id="email" name="email" class="form-control" :class="{ 'is-invalid': submitted && $v.user.email.$error }" />
                                            <div v-if="submitted && $v.user.email.$error" class="invalid-feedback">
                                                <span v-if="!$v.user.email.required">Email is required</span>
                                                <span v-if="!$v.user.email.email">Email is invalid</span>
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label for="password" class="col-form-label">Password <span>*</span></label>
                                          <div class="password-eye" :class="{ 'eye-right': submitted && $v.user.password.$error }">
                                            <i :class="'fa ' + (showEye ? 'fa-eye' : 'fa-eye-slash')" @click="showEye = !showEye"></i>
                                            <input :type="showEye ? 'password' : 'text'" v-model="user.password" id="password" name="password" class="form-control" :class="{ 'is-invalid': submitted && $v.user.password.$error }" />
                                          </div>

                                            <div v-if="submitted && $v.user.password.$error" class="invalid-feedback" style="display: flex;flex-direction: column">
                                                <span v-if="!$v.user.password.required">Password is required</span>
                                                <span v-if="!$v.user.password.password6Characters && $v.user.password.required">Password must be at least 6 characters</span>
                                                <span v-if="!$v.user.password.passwordCapitalLetter && $v.user.password.required">Password must have at least one capital letter</span>
                                                <span v-if="!$v.user.password.passwordNumber && $v.user.password.required">Password must have at least one number</span>
                                                <span v-if="!$v.user.password.passwordSymbol && $v.user.password.required">Password must have at least one special symbol</span>
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label for="confirmPassword" class="col-form-label">Confirm Password <span>*</span></label>
                                            <input type="password" v-model="user.confirmPassword" id="confirmPassword" name="confirmPassword" class="form-control" :class="{ 'is-invalid': submitted && $v.user.confirmPassword.$error }" />
                                            <div v-if="submitted && $v.user.confirmPassword.$error" class="invalid-feedback">
                                                <span v-if="!$v.user.confirmPassword.required">Confirm Password is required</span>
                                                <span v-else-if="!$v.user.confirmPassword.sameAsPassword">Passwords must match</span>
                                            </div>
                                        </div>
                                        <div class="form-row">
                                            <div class="col-sm-4">
                                                <div class="loading-wrapper">
                                                    <div class="btn-loading" v-if="loading">
                                                        <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
                                                    </div>
                                                    <button class="btn btn-primary">Sign Up</button>
                                                </div>
                                            </div>
                                            <div class="col-sm-8">
                                                <div class="text-left mt-2 m-l-20">
                                                    Are you already a user?
                                                    <router-link to="/auth/login" class="btn-link text-capitalize">
                                                        Login
                                                    </router-link>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- sign up page ends-->
        </div>

        <div class="registration_confirmation-wrapper" :class="{'show': showModal}">
            <div class="registration_confirmation-box">
                <div class="text-center mb-4"><img src="../assets/images/logo-dark.png" width="150" alt=""></div>
                <div class="registration_confirmation card">
                    <div class="card-header">
                        <h3 class="text-center">Registration Confirmation</h3>
                    </div>
                    <div class="card-body">
                        <p>
                            The confirmation was sent to <b>{{user.email}}</b>. Please check your email to continue the process. After your email has been verified you can log in.
                        </p>
                    </div>
                    <router-link to="/auth/login" tag="div" class="card-footer bg-primary text-center user-">
                        LOGIN
                    </router-link>
                </div>
            </div>
        </div>
    </div>
    <!-- page-wrapper Ends-->
</template>

<script>
  import {required, email, sameAs} from "vuelidate/lib/validators";
  import zapier from "../services/zapier";

  export default {
    name: 'signUp',
    data() {
      return {
        user: {
          firstName: "",
          lastName: "",
          email: "",
          password: "",
          confirmPassword: "",
          companyName: "",
          tokenProvider: 'Dashboard'
        },
        submitted: false,
        loading: false,
        showModal: false,
        showEye: true
      };
    },
    validations: {
      user: {
        firstName: { required },
        lastName: { required },
        email: { required, email },
        password: { required,
          password6Characters:(password) => {
            return password.length >= 6
          },
          passwordCapitalLetter: (password) => {
            return /[A-Z]/.test(password)
          },
          passwordNumber: (password) => {
            return /[0-9]/.test(password)
          },
          passwordSymbol: (password) => {
            return /[-!@#$%^&*()_+|~=`{}[\]:";'<>?,./]/.test(password)
          }
        },
        confirmPassword: { required, sameAsPassword: sameAs('password') }
      }
    },
    methods: {
      handleSubmit() {
        this.submitted = true;

        // stop here if form is invalid
        this.$v.$touch();
        if (this.$v.$invalid) {
          return;
        }

        this.loading = true;

        let user = {
          firstName: this.user.firstName,
          lastName: this.user.lastName,
          email: this.user.email,
          password: this.user.password,
          companyName: this.user.companyName,
          tokenProvider: this.user.tokenProvider
        };

        this.$store.dispatch('registerUser', user)
        .then(async (val) => {
          if (val.data.statusCode === 200) {
            this.showModal = true;
            document.body.style.overflow = 'hidden';
            await zapier.registerForAccount(user);
          }
          else {
            this.$toasted.show(val.data.result, {
              theme: 'bubble',
              position: "bottom-right",
              type: 'error',
              duration: 4000
            });
          }

          this.loading = false;
        })
        .catch(() => {
          this.$toasted.show('Please try again', {
            theme: 'bubble',
            position: "bottom-right",
            type: 'error',
            duration: 2000
          });

          this.loading = false;
        });
      }
    }
  }
</script>
<style scoped lang="scss">
    .registration_confirmation-wrapper {
        position: fixed;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        z-index: 111;
        background-color: #f8f8f8;
        opacity: 0;
        visibility: hidden;
        transition: 0.3s;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .registration_confirmation-wrapper.show {
        opacity: 1;
        visibility: visible;
    }

    .registration_confirmation-wrapper .registration_confirmation {
        width: 600px;
    }

    .registration_confirmation-wrapper .registration_confirmation p {
        font-size: 18px;
        text-align: center;
        color: #494949;
    }

    .registration_confirmation-wrapper .registration_confirmation .card-footer {
        user-select: none;
        cursor: pointer;
    }
    .page-wrapper {
      min-height: 100vh;
      display: flex;
      align-items: center;
    }
    .authentication-main .auth-innerright {
      min-height: auto !important;
    }
    .authentication-main {
      min-height: 100vh;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .invalid-feedback {
        display: flex !important;
    }
    .form-group label>span {
      color: #dc3545;
    }

    .password-eye {
      position: relative;

      i {
        position: absolute;
        z-index: 2;
        right: 10px;
        top: 50%;
        transform: translateY(-50%);
        color: #7a7a7a;
        font-size: 17px;
        cursor: pointer;
      }

      &.eye-right {
        i {
          right: 32px;
        }
      }
    }

    @media (max-width: 600px) {
        .registration_confirmation-box {
            width: 100%;
        }
        .registration_confirmation-wrapper {
            padding: 0 15px;
        }
        .registration_confirmation-wrapper .registration_confirmation {
            width: 100%;
        }
        .registration_confirmation-wrapper .registration_confirmation h3 {
            font-size: 20px;
        }
        .registration_confirmation-wrapper .registration_confirmation p {
            font-size: 16px;
        }
    }
</style>
